export default "__VITE_ASSET__3khhp3H___"